import * as React from 'react';
import * as style from './ProblemLabel.css';
import { UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconProductWarning24 } from '@cian/ui-kit-design-tokens/icons';
import { IReliabilityBanner } from '../../types/reliability/banner';

interface IProblemLabelProps {
  reliabilityBanner: IReliabilityBanner;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export const ProblemBanner = ({ reliabilityBanner, onClick }: IProblemLabelProps) => {
  return (
    <div className={style['container']} onClick={onClick} data-testid="ProblemBanner">
      <div className={style['logo-block']}>
        <IconProductWarning24 color="icon-negative-default" />
      </div>
      <div className={style['info-block']}>
        <UIHeading4 as="h4">{reliabilityBanner.title}</UIHeading4>
        <UIText1>{reliabilityBanner.label}</UIText1>
      </div>
    </div>
  );
};
